import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@folio/stripes/components';
import { useStripes } from '@folio/stripes/core';
import { OAI_HARVEST_CAPABILITY } from '../utils/settingsAccess';
var OAI_HARVEST_PATH = '/czna-authorities/oai-harvest';
/**
 * Settings nav button for Nastavení → Sklizeň OAI (CZNA-1562). Mirrors
 * `VocabularyTypesNavButton`; shown to whoever may read the harvest endpoints
 * (UX gate; the backend answers 403 either way).
 */
var OaiHarvestNavButton = function () {
    var history = useHistory();
    var pathname = useLocation().pathname;
    var intl = useIntl();
    var stripes = useStripes();
    var handleClick = useCallback(function () {
        if (pathname !== OAI_HARVEST_PATH)
            history.push(OAI_HARVEST_PATH);
    }, [history, pathname]);
    if (!stripes.hasPerm(OAI_HARVEST_CAPABILITY))
        return null;
    var isActive = pathname === OAI_HARVEST_PATH || pathname.startsWith("".concat(OAI_HARVEST_PATH, "/"));
    return (React.createElement(Button, { onClick: handleClick, buttonStyle: isActive ? 'primary' : 'default', fullWidth: true, marginBottom0: true, style: { justifyContent: 'flex-start' }, "aria-current": isActive ? 'page' : undefined, "data-testid": "settings-nav-oai-harvest" },
        React.createElement("span", { style: { marginLeft: '0.5rem' } }, intl.formatMessage({ id: 'ui-czna-authorities.navigation.oaiHarvest' }))));
};
export default OaiHarvestNavButton;
